import {
  withTranslation,
} from 'react-i18next';

import FooterView from './FooterView';

const TranslatedComponent = withTranslation()(FooterView);

const Component = TranslatedComponent;

export default Component;
